<template>
  <div>
    <Toast
      :show.sync="toast.show"
      :message="toast.message"
      :tipe="toast.tipe"
      @close="toast.show = false"
      :position="toast.position"
      :icon="toast.icon"
    ></Toast>
    <!-- App Header -->
    <div class="appHeader bg-primary text-light shadow-header-footer">
      <div class="left">
        <router-link :to="{ name: 'account' }" class="headerButton">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </router-link>
      </div>
      <div class="pageTitle">Kata Sandi</div>
    </div>
    <!-- * App Header -->
    <!-- App Capsule -->
    <div id="appCapsule">
      <div class="section inset mt-2">
        <div class="pl-1 pr-1">
          <div class="form-group boxed">
            <label class="label">Pertanyaan Kemanan</label>
            <select class="form-control" v-model="data.security_question">
              <option value="" disabled>-- Pilih Pertanyaan --</option>
              <option value="Dimana ayah Anda dilahirkan?"
                >Dimana ayah Anda dilahirkan?</option
              >
              <option value="Dimana ibu Anda dilahirkan?"
                >Dimana ibu Anda dilahirkan?</option
              >
              <option value="Siapa nama hewan peliharaan Anda?"
                >Siapa nama hewan peliharaan Anda?</option
              >
              <option value="Apa makanan favorit Anda?"
                >Apa makanan favorit Anda?</option
              >
              <option value="Apa nama tempat wisata yang ingin Anda kunjungi?"
                >Apa tempat wisata yang ingin Anda kunjungi?</option
              >
            </select>
          </div>
          <div class="form-group basic">
            <label class="label">Jawaban</label>
            <input
              type="text"
              class="form-control text-capitalize"
              v-model="data.security_answer"
            />
          </div>
          <div class="form-group basic">
            <label class="label mb-1">Kode OTP</label>
            <div class="input-group">
              <input
                type="number"
                class="form-control"
                v-model="data.confirm_code"
                placeholder="Ketik disini"
              />
              <div class="input-group-append">
                <span class="input-group-text text-primary">
                  <a href="Javascript:;" @click="showSender()"
                    ><small>Minta OTP</small></a
                  >
                </span>
              </div>
            </div>
          </div>
          <div class="form-group basic">
            <button
              class="btn btn-primary btn-block btn-lg"
              @click="showDialog('show')"
            >
              Simpan
            </button>
          </div>
        </div>
      </div>
    </div>

    <Dialog
      ref="dialog"
      :loading="dialogLoading"
      :title="'Simpan'"
      @confirm="submit()"
    >
      <p>Anda yakin akan melakukan perubahan pertanyaan keamanan?</p>
    </Dialog>

    <action-sheet-sender
      ref="sender"
      :phone="customer.phone"
      :inset="true"
    ></action-sheet-sender>
  </div>
</template>
<script>
import { mapState } from "vuex";
import $axios from "./../../api.js";
export default {
  name: "account.question",
  data() {
    return {
      dialogLoading: false,
      data: {
        security_question: "",
        security_answer: "",
        confirm_code: "",
      },
    };
  },
  created() {},
  computed: {
    ...mapState(["toast", "customer"]),
  },
  methods: {
    showDialog(value) {
      let element = this.$refs.dialog.$el;
      window.$(element).modal(value);
    },
    showSender() {
      let element = this.$refs.sender.$el;
      window.$(element).modal("show");
    },
    submit() {
      this.dialogLoading = true;
      $axios
        .post("/question", this.data)
        .then((response) => {
          this.showDialog("hide");
          this.dialogLoading = false;
          this.data = {
            security_question: "",
            security_answer: "",
            confirm_code: "",
          };
          this.$store.commit("SET_TOAST", {
            show: true,
            message: response.data.message,
            tipe: "default",
            icon: "success",
          });
        })
        .catch((error) => {
          this.$store.commit("SET_TOAST", {
            show: true,
            message: error.response.data.message,
            tipe: "default",
            icon: "danger",
          });
          this.showDialog("hide");
          this.dialogLoading = false;
        });
    },
  },
  destroyed() {
    this.$store.commit("RESET_TOAST");
  },
};
</script>
